import { triggerAction } from "./client-gen/index.js";
//TODO: use prebuilt client (see comment in openapi-ts.config.ts)?
import { client } from "./client-gen/client.gen.js";
/**
 * @todo: describe interface
 */
export const makeSrvLgApiConnector = () => {
    client.setConfig({
        baseUrl: process.env.LG_API_URL || "http://localhost:3333/v1",
        auth: () => process.env.LG_AUTH_API_KEY || "",
    });
    return {
        triggerLanded: async (initialIdentityPayload, common) => {
            const res = await triggerAction({
                body: {
                    trigger: "LANDED",
                    initialIdentityPayload,
                    ...common,
                },
            });
            return res.data;
        },
        triggerOfferSelected: async (offerKey, payload, common) => {
            const res = await triggerAction({
                body: {
                    trigger: "OFFER_SELECTED",
                    selectedOffer: {
                        key: offerKey,
                        payload,
                    },
                    ...common,
                },
            });
            return res.data;
        },
        triggerSubmitted: async (formKey, data, common) => {
            const res = await triggerAction({
                body: {
                    trigger: "SUBMITTED",
                    form: {
                        key: formKey,
                        payload: data,
                    },
                    ...common,
                },
            });
            return res.data;
        },
        triggerPoll: async (requestId, common) => {
            const res = await triggerAction({
                body: {
                    trigger: "POLL",
                    pollingRequestId: requestId,
                    ...common,
                },
            });
            return res.data;
        },
    };
};
